import { appBaseUrl } from "utils/config";
import { getService, postService, putService } from "services/commonServices";
import queryString from "query-string";

export class BlogService {
  createManagementBlogMessage(body) {
    let url = `${appBaseUrl}/referenceManagement/managementPost`;
    let data = postService(url, body);
    return data;
  }

  updateManagementBlogMessage(id, body) {
    let url = `${appBaseUrl}/referenceManagement/ManagementUpdatePost/${id}`;
    let data = putService(url, body);
    return data;
  }

  getManagementBlogMessagePagination(q) {
    let query = queryString.stringify(q);
    let url = `${appBaseUrl}/referenceManagement/channelManagementPostPagination?${query}`;
    let data = getService(url);
    return data;
  }
}
